import "../node_modules/leaflet/dist/leaflet";
import { icon, Marker } from "leaflet";
import "../node_modules/leaflet.markercluster/dist/leaflet.markercluster-src";
import "../node_modules/leaflet/dist/leaflet.css";
import "../node_modules/leaflet.markercluster/dist/MarkerCluster.css";
import "../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css";
import { useFetch, usePost } from "./fetch";
import { renderBlocs } from "./blocs";
import { string_to_slug, mutation, capitalizeFirstName } from "./utils";

let personalAdherents = [];
let structureAdherents = [];
let mymap;
let markers;
let redIcon;

// Fonction pour normaliser les chaînes (enlever les accents)
function normalizeString(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

/* async function postArchive(adherents) {
  console.log(`adherents`, adherents);
  adherents.map(async (adherent, id) => {
    let response = await usePost("carte-adherents-2-s", adherent);
  });
} */

function setMap() {
  // change icon url
  const iconRetinaUrl =
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png";
  const iconUrl = "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png";
  const shadowUrl =
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png";
  const iconDefault = icon({
    iconRetinaUrl,
    iconUrl,
    shadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41],
  });
  Marker.prototype.options.icon = iconDefault;

  console.log("Initialisation de la carte...");
  mymap = L.map("mapid").setView([46.8, 2.65], 6);

  L.tileLayer(
    "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
    {
      attribution:
        'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      maxZoom: 18,
      id: "mapbox/streets-v11",
      tileSize: 512,
      zoomOffset: -1,
      accessToken:
        "pk.eyJ1IjoicGFibG9za3oiLCJhIjoiY2txbDR0YnlnM3d4YTMybXZ3MXowN3EzNCJ9.POXNeEBjRqIk39-BQI7F0A",
    }
  ).addTo(mymap);

  console.log("Initialisation du clustering...");
  markers = L.markerClusterGroup({
    chunkedLoading: true,
    iconCreateFunction: function (cluster) {
      return L.divIcon({
        html: `<div class="cluster">${cluster.getChildCount()}</div>`,
      });
    },
    polygonOptions: { color: "#8d1f7e" },
  });

  // Create a red marker

  redIcon = new L.Icon({
    iconUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
    shadowUrl:
      "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  /* const marker = L.marker(
    [
      parseFloat(adherent.personalLatitude),
      parseFloat(adherent.personalLongitude),
    ],
    { icon: redIcon }
  ).bindPopup(HTML); */

  async function placeMarkers() {
    let response = await useFetch("carte-adherents-2s?pagination[pageSize]=2000");

    console.log("Données reçues de l'API:", response);
    console.log("Nombre d'adhérents:", response ? response.length : 0);

    // Vérification que response est un tableau
    if (!response || !Array.isArray(response)) {
      console.error("La réponse de l'API n'est pas un tableau valide:", response);
      return;
    }

    let archive = [];
    let markersCreated = 0;

    response.forEach((adherent) => {
      /* INDIVIDUELS */
      // Old
      /* if (adherent.personalZipcode && adherent.firstName && adherent.lastName) {
        personalAdherents.push(adherent);
      } */
      // New
      if (adherent.type === "individuel") {
        personalAdherents.push(adherent);
        console.log("Adhérent individuel ajouté:", adherent);
      }

      // STRUCTURES
      // Old
      /* if (
        adherent.professionalLongitude &&
        adherent.professionalLatitude &&
        adherent.structureName
      ) {
        archive.push({
          adherent: false,
          type: "structure",
          structureName: adherent.structureName,
          structureAddress: adherent.professionalFullAdress,
          structureLat: adherent.professionalLatitude,
          structureLong: adherent.professionalLongitude,
          structureWebsite: adherent.structureWebsite,
        });
        let marker = L.marker([
          parseFloat(adherent.professionalLatitude),
          parseFloat(adherent.professionalLongitude),
        ]).bindPopup(
          `${
            adherent.structureName
              ? "<span class='bold'>" + adherent.structureName + "</span><br>"
              : ""
          }
          ${
            adherent.structureWebsite
              ? "Site web : <a href='" +
                adherent.structureWebsite +
                "' target='_blank'>" +
                adherent.structureWebsite +
                "</a><br>"
              : ""
          }
           ${
             adherent.professionalPhone
               ? "Téléphone : <a href='tel:" +
                 adherent.professionalPhone +
                 "'>" +
                 adherent.professionalPhone +
                 "</a><br>"
               : ""
           }
           ${
             adherent.professionalEmail
               ? "Email : <a href='mailto:" +
                 adherent.professionalEmail +
                 "'>" +
                 adherent.professionalEmail +
                 "</a><br>"
               : ""
           }`
        );
        if (adherent.structureWebsite) {
          marker.options.icon = redIcon;
        }
        markers.addLayer(marker);
      } */
      // New
      if (adherent.type === "structure") {
        // Ajouter la structure au tableau pour la recherche
        structureAdherents.push(adherent);

        console.log("Structure trouvée:", adherent.structureName, {
          lat: adherent.structureLat,
          long: adherent.structureLong,
          adherent: adherent.adherent
        });

        // Validation des coordonnées - vérifier qu'elles existent avant de parser
        if (!adherent.structureLat || !adherent.structureLong) {
          console.warn("Coordonnées manquantes pour:", adherent.structureName);
          return; // Skip cette structure pour la carte mais gardée pour la recherche
        }

        const lat = parseFloat(adherent.structureLat);
        const lng = parseFloat(adherent.structureLong);

        if (isNaN(lat) || isNaN(lng)) {
          console.warn("Coordonnées invalides pour:", adherent.structureName, {
            lat: adherent.structureLat,
            long: adherent.structureLong
          });
          return; // Skip cette structure
        }

        if (
          adherent.structureWebsite &&
          adherent.structureWebsite.substring(0, 4) !== "http"
        ) {
          adherent.structureWebsite = "http://" + adherent.structureWebsite;
        }

        console.log(`Création du marqueur pour ${adherent.structureName} à [${lat}, ${lng}]`);

        try {
          let marker = L.marker([lat, lng]).bindPopup(
            `${
            adherent.structureName
              ? "<span class='bold'>" + adherent.structureName + "</span><br>"
              : ""
          }
          ${adherent.structureAddress ? adherent.structureAddress + "<br>" : ""}
          ${
            adherent.structureWebsite
              ? "Site web : <a href='" +
                adherent.structureWebsite +
                "' target='_blank'>" +
                adherent.structureWebsite +
                "</a><br>"
              : ""
          }`
          );
          if (adherent.adherent) {
            marker.options.icon = redIcon;
          }
          markers.addLayer(marker);
          markersCreated++;
          console.log(`Marqueur créé pour: ${adherent.structureName} - Total: ${markersCreated}`);
        } catch (error) {
          console.error(`Erreur lors de la création du marqueur pour ${adherent.structureName}:`, error);
          console.error("Coordonnées utilisées:", [lat, lng]);
        }
      }
    });
    // postArchive(archive);
    console.log(`Total de marqueurs créés: ${markersCreated}`);
    console.log("Ajout du layer de clusters à la carte...");
    mymap.addLayer(markers);
  }

  placeMarkers();
  handleSearch();
}

async function handleSearch() {
  const $zip = document.getElementById("zip");
  const $zipList = document.getElementById("zipList");
  console.log(`Nombre d'adhérents individuels: ${personalAdherents.length}`);
  console.log(`Nombre de structures: ${structureAdherents.length}`);

  $zip.addEventListener("input", (ev) => {
    ev.preventDefault();
    $zipList.innerHTML = "";
    const searchValue = $zip.value.toLowerCase();
    const normalizedSearchValue = normalizeString($zip.value);

    if (searchValue.length < 2) {
      return; // Ne chercher qu'à partir de 2 caractères
    }

    console.log(`Recherche pour: "${searchValue}" (normalisé: "${normalizedSearchValue}")`);

    // Recherche dans les adhérents individuels
    personalAdherents.forEach((adherent) => {
      // Vérification des propriétés
      if (!adherent.zipcode || !adherent.firstName || !adherent.lastName) {
        console.warn("Adhérent individuel avec propriétés manquantes:", adherent);
        return;
      }

      // Recherche par code postal ou nom/prénom normalisé
      const normalizedFirstName = normalizeString(adherent.firstName || "");
      const normalizedLastName = normalizeString(adherent.lastName || "");
      const normalizedProfession = normalizeString(adherent.profession || "");

      if (adherent.zipcode.substring(0, searchValue.length) === searchValue ||
          normalizedFirstName.includes(normalizedSearchValue) ||
          normalizedLastName.includes(normalizedSearchValue) ||
          normalizedProfession.includes(normalizedSearchValue)) {

        $zipList.innerHTML += `<li style="margin:0.5rem;">
          <strong>Individuel:</strong> ${capitalizeFirstName(adherent.firstName)}
          ${adherent.lastName.toUpperCase()}
          ${adherent.profession ? ", " + adherent.profession : ""}
          (${adherent.zipcode})
        </li>`;
      }
    });

    // Recherche dans les structures
    structureAdherents.forEach((structure) => {
      if (!structure.structureName || !structure.structureAddress) {
        return;
      }

      // Normalisation pour recherche sans accents
      const normalizedStructureName = normalizeString(structure.structureName);
      const normalizedStructureAddress = normalizeString(structure.structureAddress);

      // Extraction du code postal de l'adresse (format: "... XXXXX ...")
      const zipMatch = structure.structureAddress.match(/\b\d{5}\b/);
      const structureZipcode = zipMatch ? zipMatch[0] : "";

      if (normalizedStructureName.includes(normalizedSearchValue) ||
          normalizedStructureAddress.includes(normalizedSearchValue) ||
          (structureZipcode && structureZipcode.startsWith(searchValue))) {

        $zipList.innerHTML += `<li style="margin:0.5rem;">
          <strong>Structure:</strong> ${structure.structureName}
          ${structureZipcode ? ` (${structureZipcode})` : ""}
          <br><small>${structure.structureAddress}</small>
        </li>`;
      }
    });

    // Message si aucun résultat
    if ($zipList.innerHTML === "") {
      $zipList.innerHTML = '<li style="margin:0.5rem; color: gray;">Aucun résultat trouvé</li>';
    }
  });
}

async function renderMap() {
  const $main = document.getElementById("main");
  const $banner = document.querySelector(".banner");
  $banner.style.display = "none";
  $main.classList.remove("grid");
  /* $main.innerHTML = `<h1>Carte du réseau</h1>
    <div id="mapid" class="map"></div>`; */
  let blocsHTML = await renderBlocs();

  $main.innerHTML = `<section class="map-section">
        <div class="ariane">
         <a href="/index.html">Accueil</a> / <a href="/anrat/">ANRAT</a> / Carte du réseau
        </div>
        <h1>Carte du réseau</h1>
        <!-- <p>La carte du réseau sera bientôt disponible.</p> -->
        <h3>Nos structures adhérentes <img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png"> ou simples partenaires<img src="https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png"></h3>
        <p style="font-size:1rem; margin: 1rem 0 2rem 0;"><img src="https://res.cloudinary.com/anrat/image/upload/v1639045201/clusters_xps86d.png" alt="regroupement" class="cluster-legend"> Regroupements adhérents, cliquez dessus pour zoomer.</p>
        <div id="mapid" class="map"></div>
        <hr>
        <h3 style="margin-top:2.5rem;">Recherchez parmi tous nos adhérents et structures</h3>
        <p>Pour rechercher, tapez un code postal, un nom de structure ou une partie d'adresse :</p>
          <input type="text" name="departement" id="zip" placeholder="Ex: 75, théâtre, Paris...">
        <ul id="zipList" class="zip-list">
        </ul>
        <p style="font-size:1rem;">
          Seuls les noms de celles et ceux, adhérents pour l'année en cours et qui ont autorisé la communication de leurs coordonnées apparaissent. Pour toute réclamation ou demande, envoyez un email à <a href="mailto:contact@anrat.net">contact@anrat.net</a>
        </p>
      </section>
      <div class="blocs">
        ${blocsHTML}
      </div>`;

  setTimeout(setMap, 100);
}

export { renderMap };
